export type Anchor = {
  zone: string;
};

export const isAnchorEqual = (a: Anchor, b: Anchor): boolean => {
  return a.zone === b.zone;
};

/**
 * A type that keeps the minimum information needed about a comment,
 * with the goal to help comment zones to show if there's open comments
 * or not.
 */
export type Comment = {
  name: string;
  anchor?: Anchor;
  resolved: boolean;
};
